import React, { FC } from 'react';
import { IconContainer, Label, LabelIconContainer } from './LabelIcon.styles';
import { LabelIconProps } from './types';

const LabelIcon: FC<LabelIconProps> = ({ label, icon }: LabelIconProps) => (
  <LabelIconContainer>
    <Label title={label}>{label}</Label>
    {icon ? <IconContainer aria-label={label}>{icon}</IconContainer> : null}
  </LabelIconContainer>
);

export default LabelIcon;
